import { FilterOptions, SelectedFilters } from '../../../modules/pipelines-module/@core/interfaces';
import { DEFAULT_BATCHES_PAGE_SIZE, DEFAULT_RUNS_PAGE_SIZE, DEFAULT_CURRENT_FILTERS } from '../../../modules/pipelines-module/constants';

export class PollyManageMonitoringFilterService {
  private readonly _selectedFilterOptions: { batches: SelectedFilters; runs: SelectedFilters } = {
    batches: {
      status: '',
      created_at: '',
      priority: '',
      user_name: '',
      page_size: DEFAULT_BATCHES_PAGE_SIZE,
      sort_field: '',
      sort_order: '',
      current_page: 1,
      first: 0,
    },
    runs: {
      status: '',
      created_at: '',
      priority: '',
      user_name: '',
      page_size: DEFAULT_RUNS_PAGE_SIZE,
      sort_field: '',
      sort_order: '',
      current_page: 1,
      first: 0,
    },
  };

  private readonly _currentFilterOptions: { batches: FilterOptions; runs: FilterOptions } = {
    batches: { ...DEFAULT_CURRENT_FILTERS },
    runs: { ...DEFAULT_CURRENT_FILTERS },
  };

  public get selectedFilters(): { batches: SelectedFilters; runs: SelectedFilters } {
    return this._selectedFilterOptions;
  }

  public get currentFilters(): { batches: FilterOptions; runs: FilterOptions } {
    return this._currentFilterOptions;
  }

  public set currentFilters(currentFilters: { batches: FilterOptions; runs: FilterOptions }) {
    this._currentFilterOptions.batches = { ...currentFilters.batches };
    this._currentFilterOptions.runs = { ...currentFilters.runs };
  }

  public set selectedFilters(selectedFilters: { batches: SelectedFilters; runs: SelectedFilters }) {
    this._selectedFilterOptions.batches = { ...selectedFilters.batches };
    this._selectedFilterOptions.runs = { ...selectedFilters.runs };
  }
}
